import { useEffect, useRef } from 'react';

import { useProductSearchStateContext } from '../../../../search/hooks/useProductSearchStateContext';

export const useSearchOverlayAnnounce = (
    createResultMessage: (
        visibleResults: number,
        totalResults: number,
        queryUsed?: string,
    ) => string,
) => {
    const { result, queryUsed, setA11yResultAnnounceMessage } = useProductSearchStateContext();

    const hasResults = !!result && result.items.length > 0;
    const hasDifferentQueriesUsed = !!queryUsed && queryUsed !== result?.query;

    const createMessageRef = useRef(createResultMessage);

    useEffect(() => {
        const message = [];

        if (hasResults) {
            const resultMessage = createMessageRef.current(
                result.items.length,
                result.totalResults,
                queryUsed,
            );

            message.push(resultMessage);
        }

        if (message.length > 0) {
            setA11yResultAnnounceMessage(message.join('. '));
        }
    }, [hasResults, result, queryUsed, setA11yResultAnnounceMessage, hasDifferentQueriesUsed]);
};
